import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross-doodle.svg';
import ProductItemWebForm from '~/components/organisms/Webform/ProductItemWebForm';
import QuantitySelector from '~/components/atoms/WebForm/QuantitySelector';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
export default {
  name: 'ListProductItem',
  components: {
    ProductItemWebForm,
    QuantitySelector,
    MdmIcon
  },
  props: {
    products: {
      type: Array,
      required: true
    },
    showBackBtn: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,

      default() {
        return [];
      }

    }
  },

  data() {
    return {
      selectedProducts: {}
    };
  },

  computed: {
    isNoProductSelected() {
      return !Object.values(this.selectedProducts).length;
    }

  },
  watch: {
    selectedProducts() {
      this.$emit('update-products', this.selectedProducts);
    }

  },
  methods: {
    updateQuantity(quantity, key) {
      this.selectedProducts[key].quantity = quantity;
    },

    isProductSelected(key) {
      return this.selectedProducts[key];
    },

    selectProduct(key, name) {
      this.selectedProducts = _objectSpread(_objectSpread({}, this.selectedProducts), {}, {
        [key]: {
          productId: key,
          quantity: 1,
          name
        }
      });
    },

    cancel(key) {
      var _this$selectedProduct = this.selectedProducts,
          {
        [key]: deletedProduct
      } = _this$selectedProduct,
          remainingProducts = _objectWithoutProperties(_this$selectedProduct, [key].map(_toPropertyKey));

      this.selectedProducts = remainingProducts;
    },

    initialQuantity(ref) {
      return this.selectedProducts[ref] ? this.selectedProducts[ref].quantity : 1;
    },

    selectAllProducts() {
      this.products.forEach((_ref) => {
        var {
          reference,
          name,
          quantity
        } = _ref;
        this.selectedProducts = _objectSpread(_objectSpread({}, this.selectedProducts), {}, {
          [reference]: {
            productId: reference,
            quantity,
            name
          }
        });
      });
    },

    formatAndEmitProducts() {
      this.$emit('update-products', Object.values(this.selectedProducts));
    }

  }
};